<div class="column">
    <div class="row a_center" *ngFor="let item of list" [ngClass]="{'active': item.active}">
        <mat-checkbox (change)="onChange(item)" [(ngModel)]="item.active">{{item.name}}</mat-checkbox>
    </div>
</div>